module.exports = __webpack_public_path__ + "img/f-hi.2e4ff9cc.png";